import React, { useRef } from "react"
import API from "../../api"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import TextInputField from "../../components/textInput"
import Button from "../../components/button"
import { useLanguage } from "@languages/index"
import { batch } from "react-redux"
import USER from "@constants/user"
import BRAND from "@constants/brand"
import { ROUTES } from "../../routes"
import { useNavigate } from "react-router-dom"
import DOMAIN from "@constants/domain"
import OverlayMatchRatingSettingWithSteps from "components/overlayMatchRatingSettingWithSteps"
import { isGlovv, isKyolook, isOneulook } from "constants/domains/domains"
import URLS from "constants/urls"

const AuthIndex = (props: any) => {
  const navigate = useNavigate()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.auth }

  const userId = useRef<string>("")
  const password = useRef<string>("")

  const fetchBrand = async (token) => {
    const response = await API.Brand.show({ brandToken: token })
    const _brand = response.data.brand
    props.setBrand(_brand)
    return _brand
  }

  const submitLogin = async () => {
    await API.Auth.login({ user_id: userId.current, password: password.current })
      .then(async (response) => {
        batch(() => {
          props.setAuth({
            token: response.data.token,
            isMaster: response.data.user.is_master,
            masterToken: response.data.user.master_token,
          })

          props.setUser(response.data.user)
        })

        const brand = await fetchBrand(response.data.token)
        const isAmbassadorEnabled =
          brand.rentableUserTypeFl.includes(USER.TYPE.RENTAL_AMBASSADOR) && brand.isAmbassadorServiceEnabled
        const isBeautyCategoryBrand = brand?.isCategoryBeauty

        if (BRAND.isLectureOnlyBrand(brand.id)) {
          navigate(ROUTES.LECTURE_INDEX.PATH);
          return false
        }

        if (!brand.hasExperiencedMatchRatingCreate && !isBeautyCategoryBrand) {
          setTimeout(() => {
            props.showOverlays({
              preventClose: false,
              content: () => {
                return <OverlayMatchRatingSettingWithSteps {...props} hasCloseButton={false} />
              },
            })
          }, 500)
        }

        if (brand.productsInRentableCount == 0 && brand.hasExperiencedCampaign) {
          navigate(ROUTES.CAMPAIGN_INDEX.PATH, { replace: true })
          return false
        }

        if (brand.businessType == BRAND.BUSINESS_TYPE.NORMAL && isAmbassadorEnabled) {
          navigate(ROUTES.RENTAL_AMBASSADOR_INDEX.PATH, {
            state: {
              scrollTo: "applicantsSectionStartRef",
            },
          })
          return false
        }

        if (
          brand.hasExperiencedInfoUpdate == false ||
          brand.hasExperiencedAlarmUpdate == false ||
          brand.hasExperiencedPasswordUpdate == false
        ) {
          navigate(ROUTES.HELP_MISSIONS.PATH)
          return false
        }
      })
      .catch((error) => {
        props.showModal({ text: error.data })
      })
  }

  const getContactLink = () => {
    const currentUrl = window.location.href

    const subdomainPattern = /^(https?:\/\/)([^.]+)\.oneulook\.com/

    const matches = currentUrl.match(subdomainPattern)

    if (matches && matches.length > 2) {
      const subdomain = matches[2]
      // const newPath = "/brand/contact?type=SEEDING"
      const redirectUrl = "https://" + subdomain + "." + DOMAIN.BASE.URL

      return redirectUrl
    }

    if (isKyolook() && isOneulook()) {
      return "https://" + DOMAIN.BASE.URL + "/brand/contact?type=SEEDING"
    } else if (isGlovv()) {
      return "https://glovv.co.kr"
    }
  }

  const RESOURCE_CACHE_KEY_FOR_BRAND_GLOVV_AUTH_VIDEO = '202510301427';
  
  return (
    <div className="flex flex-row">
      <div className="hidden flex-1 md:block relative overflow-hidden">
        {isGlovv() ? (
          <video className="h-[100vh] w-full object-cover" autoPlay loop muted playsInline>
            <source src={`${URLS?.CDN?.BRAND?.VIDEOS?.AUTH?.URL + '/brand_glovv_auth_video.mp4' + "?v=" + RESOURCE_CACHE_KEY_FOR_BRAND_GLOVV_AUTH_VIDEO}`} type="video/mp4" />
          </video>
        ) : (
          <div className="w-full h-full bg-no-repeat bg-cover bg-center bg-[url('/assets/images/login/login-hero-desktop.webp')]" />
        )}
      </div>
      <div className="flex-1 h-[100vh] flex items-center justify-center md:bg-none relative overflow-hidden">
        {isGlovv() ? (
          <video
            className="absolute top-1/2 left-0 w-full h-full -translate-y-1/2 object-cover md:hidden z-[-1]"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={`${URLS?.CDN?.BRAND?.VIDEOS?.AUTH?.URL + '/brand_glovv_auth_video.mp4' + "?v=" + RESOURCE_CACHE_KEY_FOR_BRAND_GLOVV_AUTH_VIDEO}`} type="video/mp4" />
          </video>
        ) : (
          <div className="fixed top-0 left-0 w-full h-full md:hidden bg-no-repeat bg-cover bg-center bg-[url('/assets/images/login/login-hero-2x.webp')] z-[-1]" />
        )}
        <div className="flex flex-col w-full max-w-[335px] px-5 py-8 bg-white">
          <p className="mb-2 text-sm text-center tracking-tighter ">{languageTexts.title}</p>
          <p className="mb-8 text-2xl font-bold text-center tracking-tighter whitespace-pre-wrap">
            {languageTexts.login_first}
          </p>
          <div className="flex flex-col w-full gap-3">
            <div className="flex flex-row">
              <TextInputField
                inputClassName="py-2 px-4"
                bordered
                borderColor="#EFEFEF"
                placeholder={languageTexts.id}
                onChangeText={(value) => {
                  userId.current = value
                }}
              />
            </div>

            <div className="flex flex-row">
              <TextInputField
                inputClassName="py-2 px-4"
                bordered
                borderColor="#EFEFEF"
                placeholder={languageTexts.password}
                type="password"
                onChangeText={(value) => {
                  password.current = value
                }}
              />
            </div>

            <div className="flex flex-row">
              <Button
                text={languageTexts.login}
                buttonColor="BLACK"
                textColor="WHITE"
                onClick={() => {
                  submitLogin()
                }}
              />
            </div>
          </div>

          <div className="flex flex-col w-full mt-8">
            <div className="flex flex-col items-center gap-3 text-sm text-center text-gray-400 ">
              <p>
                {languageTexts.desc_1}
                <br />
                {languageTexts.desc_2}
              </p>
              <p>
                {languageTexts.manager}
                <br />
                {languageTexts.manager_tel}
              </p>
              {languageTexts._contact_text(getContactLink())}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(AuthIndex)
